import React, {Component} from 'react'
import DatePicker from 'react-datepicker'
import moment from 'moment'

import 'react-datepicker/dist/react-datepicker.css'
import 'react-datepicker/dist/react-datepicker-cssmodules.css'

export default class DatePickerFormComponent extends Component {
  onChange (value) {
    if (value) {
      this.props.input.onChange(value.format())
      if (this.props.onDateChange) {
        this.props.onDateChange(value.format())
      }
    }
  }

  render () {
    return (<div>
      <DatePicker
        {...this.props}
        required={this.props.required}
        className={this.props.className}
        selected={this.props.input.value ? moment(this.props.input.value) : null}
        onChange={this.onChange.bind(this)}
        {...this.props} />
    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/components/redux-form/DatePickerFormComponent.js